import { render, staticRenderFns } from "./KuesionerKompetensiDetail.vue?vue&type=template&id=94963b94&scoped=true&lang=html&"
import script from "./KuesionerKompetensiDetail.vue?vue&type=script&lang=js&"
export * from "./KuesionerKompetensiDetail.vue?vue&type=script&lang=js&"
import style0 from "./KuesionerKompetensiDetail.vue?vue&type=style&index=0&id=94963b94&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94963b94",
  null
  
)

export default component.exports